// import React,{useState,useEffect} from 'react';
// import { OpenAIApi } from 'openai';
// import { Configuration } from 'openai';
// // import regexParser from 'regex-parser';


// // PROMPTSSSSSS

// // -----------------------------------
// // Establish all of the people to include in the chart:
// // <code> for (let i = 0; i < promptNames.length; i ++)
// // {let |name| = promptNames[i];  
// //   </code>
// //  Response Format:
// //  <ul>
// //   <h1>
// //   ${promptDate}
// //   </h1>



// //         <li class="line"></li>
// // <li>|name|</li>
// //   <li> Chore:</li> 
// //   <li>Time to complete: </li>
// //   <li>Incentive:</li>
// //   <li> Fun Fact:</li>
// //   <li>Inspirational Quote: </li>
// // </ul>
// // <ul>


// // Response Rule:The response must be formatted like it would be in an integrated development environment(IDE).

// //  Using the Format above, create a fun interactive chore chart for the week. Be especially creating for the kids, and use relative learning facts for all ages. Add the dates for each of the 7 days of the week starting with ${promptDate}, and using that same format. Add corresponding <li> for each name given so that everyone has equal responsibility. Everybody, included in ${promptNames} should be doing a chore everyday, including all 7 days of the week is a must so do not render without 7 days full of different values with the same keys. The return will need to be listed and completed in the same format with different chores, times to complete, incentives, fun facts, inspirational quotes, and a points value. Please seperate each <li> with a new line. Add an peppy pep talk that will pep anyone the fuck up needs to go along for the whole week as a hole as well! Get started! No value can be the same as the next, but remember that each key is required for every day of the week. I need all seven days on the chart fast; they are coming!
 

// //  Response:
 
// // ---------------------------------








// // WORK ON THIS BIT BELOW NEXT. I WANT TO ADD REGEX AND I WANT TO ADD REAL TIME FUNCTION CHECKS / CONSOLE LOGS

// // // define a Regex object with the regex string
// // let regex = regexParser('[^\d\W, ]+');

// // // check user input against the Regex object
// // function checkInput(text) {
// //   let status= 'pending'
// //   console.log('activated checkInput function')
// //   if (regex.test()) {
// //     console.log( 'regex.test ==== true')
// //     // input is valid
// //   } else {
// //     // input is invalid
// //   }
// //   return status
// // }

// // let intervalId = setInterval(function () { 
// //   console.log(checkInput.status);//right now this is just logging undefined. GTG to bed YO , work on this next@@@@!!!!@!!@@@!@  
// // }, 1000);





// const REACT_APP_OPENAI_KEY =process.env.REACT_APP_OPENAI_KEY
// function Chores(){
//   const [promptNames, setPromptNames] = useState("");
//   const [promptDate, setPromptDate] = useState("");
//   const [promptFinal, setPromptFinal] = useState("");


//  const [result, setResult]= useState("")
//  const [isLoading, setIsLoading] = useState(false);
// const [isError, setIsError] = useState(false)



// // DEFINING OPENAI------------------------------------------------------------------------------
// const configuration = new Configuration({
//   apiKey: REACT_APP_OPENAI_KEY,
//   'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10'
// })
// const openai = new OpenAIApi(configuration);
// //DEFINING OPENAI-----------------------  --------






// // GETTING INPUT VALUES--------------------------------------------

// const handleInputNames = (text) =>{
//   setPromptNames(text)
//   console.log("HANDLE INPUT NAMES:",text)
// }




// const handleDate = (text) =>{
//   setPromptDate(text)
//   console.log("HANDLE DATE INPUT: ",text)
// }




// const handleInputChange = (text) =>{
//   setPromptNames(text)
// }


// // DONE GETTING INPUT VALUES--------------------------------------


















// // USE EFFECT HOOK ___________________----===================----USE EFFECT HOOK ________________//
//  useEffect(()=>{
//   // KEEPS TRACK OF NAME CHANGES//
// console.log("USE EFFECT HOOK PROMPT NAMES : ",promptNames)
// const listenClickName= document.getElementById('userInputFieldNames')
// console.log(handleInputChange.value)
// listenClickName.addEventListener('click',(e) => {
//   console.log("User has clicked into the Name box")
// })
//   // KEEPS TRACK OF DATE CHANGES//
//   console.log(" USE EFFECT HOOK PROMPT DATE: ", promptDate)
//   const listenClickDate= document.getElementById('userInputFieldDate')  
//   console.log(handleInputChange.value)  
//   listenClickDate.addEventListener('click',(e) => {  
//     console.log("User has clicked into the Date box")
// })

// listenClickName.addEventListener('keydown', handleInputChange)
 
//  },[promptNames, promptDate])
// // USE EFFECT HOOK ___________________----===================----USE EFFECT HOOK ________________//


// const output = document.getElementById('output')



// // MAIN FUNCTION WHEN BUTTON IS CLICKED TO SUBMIT-------------------------------------------
//   const generateChores = async() =>{
//     setIsLoading(true)
// let pn = promptNames.replace(/\w+$/, 'and $&');
//     console.log("SENDING", promptDate,"AS MONDAYS START DATE, AND", pn, "AS THE PEOPLE INCLUDED IN THE CHART to the prompt!!!")
// try{
    
//     console.log('generateChores was called, and is now in the try block') 


//     // AI CALL INSIDE MAIN FUNCTION----------------------------------
//    const res =  await openai.createCompletion({
         
            
//  prompt: `     


//  For each day of the week starting with ${promptDate}, list a chore, a points value, a fun fact, and an inspirational quote for each person named 
//  ${promptNames}. Label each date as a header before naming the chores for each person. After the last name on the first day is completed, begin the second day with a new set; continue for all 7 days..

//  //  Response Format:
// //  <ul>
// //   <h1>
// //   
// //   </h1>



// //         <li class="line"></li>
// // <li>Name</li>
// //   <li> Chore:</li> 
// //   <li>Time to complete: </li>
// //   <li>Incentive:</li>
// //   <li> Fun Fact:</li>
// //   <li>Inspirational Quote: </li>
// // </ul>
// // <ul>

// note: if oct 5 starts the week, oct 5-12 must be listed. if nov 17 starts the week, the 17-24 MUST be listed...
//  `,
 


//  model: 'text-davinci-003',
//  max_tokens:1700,
//  temperature:.743
// });


// // DONE WITH AI CALL INSIDE MAIN FUNCTION--------------------------




// setResult(res.data)

// console.log(setResult)

// console.log("RES.DATA :",res.data.choices[0].text)
// if (output){output.innerHTML = res.data.choices[0].text}
// setIsLoading(false)
// }catch(error){
// setIsLoading(false)
// console.error("FROM 'generateChores', in the catch block, THE ERROR IS RELATED TO: ",error)
// }
//  console.log('You did it bud, carry on')
// console.log("RESULT :",result)


//  }







// //  RETURN AKA FRONTEND --------------------------------

//   return (


// <div className="App">



    
//         {/* HEADER-------- */}
//         <header>
//           <div className='line'></div>
//                 <h1 className='header-content'>Create this week's chores 👎<br/> and inspirations 👍</h1>
//                 <br/>
//                 <div className='line'></div>
//         </header>

 
          
//           {/* USER INPUT NAMES------- */}
//           <h1 className='header-content'>Names</h1>

//           <textarea
//                     id="userInputFieldNames"
//                     className='content-col'
//                     placeholder="Enter the names to include in this cycle"
//                     onChange={(e) => {handleInputNames(e.target.value); setPromptNames(e.target.value)}}

//                   />
                       


//           {/* USER INPUT START DATE ----- */}
// <h1 className='header-content'>Week Start Date</h1>
//               <textarea
//                 id="userInputFieldDate"
//                 className='content-col'
//                 placeholder="Enter Monday's date in desired format."
//                 onChange={(e) => {handleDate(e.target.value); setPromptDate(e.target.value)}}
//               />

//                 <button className="btn" onClick={generateChores} >
                  
//                 {isLoading ? (
//                 <span className='btn'>
//           <i className="fa fa-spinner fa-spin loader" /> 
//                   Completing the chart for the week starting {promptDate} for {promptNames.replace(/\w+$/, 'and $&')}!
//                 </span>
//               ) : (
//                 isError ? "Error" : "Complete"
//               )}     
//               </button>


          
// <div className='line'></div>
// <div className='line'></div>
// <div className='line'></div>


//           {/* RESULTS FROM THE PROMPT---------- */}
//                 <section id='output'>
                
//                 <div id="returnedFromAi" className='col'>
//                 {result || result.length > 0 
//                 ?
//                    <div className='explore result'>
// <p id='output'>
//                     {result.choices[0].text}                                        
// </p>
                
//                 </div>  

//                 : 
//                 <>
                
//                 </>                
//               }
//                 </div></section>





//               {/* LAST DIV---- */}
//         </div>


//   );
// }
 
// export default Chores;


import React,{useState,useEffect} from 'react';
import { OpenAIApi } from 'openai';
import { Configuration } from 'openai';
// import regexParser from 'regex-parser';


// PROMPTSSSSSS

// -----------------------------------
// Establish all of the people to include in the chart:
// <code> for (let i = 0; i < promptNames.length; i ++)
// {let |name| = promptNames[i];  
//   </code>
//  Response Format:
//  <ul>
//   <h1>
//   ${promptDate}
//   </h1>



//         <li class="line"></li>
// <li>|name|</li>
//   <li> Chore:</li> 
//   <li>Time to complete: </li>
//   <li>Incentive:</li>
//   <li> Fun Fact:</li>
//   <li>Inspirational Quote: </li>
// </ul>
// <ul>


// Response Rule:The response must be formatted like it would be in an integrated development environment(IDE).

//  Using the Format above, create a fun interactive chore chart for the week. Be especially creating for the kids, and use relative learning facts for all ages. Add the dates for each of the 7 days of the week starting with ${promptDate}, and using that same format. Add corresponding <li> for each name given so that everyone has equal responsibility. Everybody, included in ${promptNames} should be doing a chore everyday, including all 7 days of the week is a must so do not render without 7 days full of different values with the same keys. The return will need to be listed and completed in the same format with different chores, times to complete, incentives, fun facts, inspirational quotes, and a points value. Please seperate each <li> with a new line. Add an peppy pep talk that will pep anyone the fuck up needs to go along for the whole week as a hole as well! Get started! No value can be the same as the next, but remember that each key is required for every day of the week. I need all seven days on the chart fast; they are coming!
 

//  Response:
 
// ---------------------------------








// WORK ON THIS BIT BELOW NEXT. I WANT TO ADD REGEX AND I WANT TO ADD REAL TIME FUNCTION CHECKS / CONSOLE LOGS

// // define a Regex object with the regex string
// let regex = regexParser('[^\d\W, ]+');

// // check user input against the Regex object
// function checkInput(text) {
//   let status= 'pending'
//   console.log('activated checkInput function')
//   if (regex.test()) {
//     console.log( 'regex.test ==== true')
//     // input is valid
//   } else {
//     // input is invalid
//   }
//   return status
// }

// let intervalId = setInterval(function () { 
//   console.log(checkInput.status);//right now this is just logging undefined. GTG to bed YO , work on this next@@@@!!!!@!!@@@!@  
// }, 1000);





const REACT_APP_OPENAI_KEY =process.env.REACT_APP_OPENAI_KEY
function Chores(){
  const [promptNames, setPromptNames] = useState("");
  const [promptDate, setPromptDate] = useState("");
  const [promptFinal, setPromptFinal] = useState("");


 const [result, setResult]= useState("")
 const [isLoading, setIsLoading] = useState(false);
const [isError, setIsError] = useState(false)



// DEFINING OPENAI------------------------------------------------------------------------------
const configuration = new Configuration({
  apiKey: REACT_APP_OPENAI_KEY,
  'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10'
})
const openai = new OpenAIApi(configuration);
//DEFINING OPENAI-----------------------  --------






// GETTING INPUT VALUES--------------------------------------------

const handleInputNames = (text) =>{
  setPromptNames(text)
  console.log("HANDLE INPUT NAMES:",text)
}




const handleDate = (text) =>{
  setPromptDate(text)
  console.log("HANDLE DATE INPUT: ",text)
}




const handleInputChange = (text) =>{
  setPromptNames(text)
}


// DONE GETTING INPUT VALUES--------------------------------------


















// USE EFFECT HOOK ___________________----===================----USE EFFECT HOOK ________________//
 useEffect(()=>{
  // KEEPS TRACK OF NAME CHANGES//
console.log("USE EFFECT HOOK PROMPT NAMES : ",promptNames)
const listenClickName= document.getElementById('userInputFieldNames')
console.log(handleInputChange.value)
listenClickName.addEventListener('click',(e) => {
  console.log("User has clicked into the Name box")
})
  // KEEPS TRACK OF DATE CHANGES//
  console.log(" USE EFFECT HOOK PROMPT DATE: ", promptDate)
  const listenClickDate= document.getElementById('userInputFieldDate')  
  console.log(handleInputChange.value)  
  listenClickDate.addEventListener('click',(e) => {  
    console.log("User has clicked into the Date box")
})

listenClickName.addEventListener('keydown', handleInputChange)
 
 },[promptNames, promptDate])
// USE EFFECT HOOK ___________________----===================----USE EFFECT HOOK ________________//


const output = document.getElementById('output')



// MAIN FUNCTION WHEN BUTTON IS CLICKED TO SUBMIT-------------------------------------------
  const generateChores = async() =>{
    setIsLoading(true)
// let pn = promptNames.replace(/\w+$/, 'and $&');
    console.log("SENDING", promptDate,"AS MONDAYS START DATE, AND", promptNames, "AS THE PEOPLE INCLUDED IN THE CHART to the prompt!!!")
try{
    
    console.log('generateChores was called, and is now in the try block') 


    // AI CALL INSIDE MAIN FUNCTION----------------------------------
   const res =  await openai.createCompletion({
         
            
//  prompt: `     


//  For each day of the week starting with ${promptDate}, list a chore, a points value, a fun fact, and an inspirational quote for each person named 
//  ${promptNames}. Label each date as a header before naming the chores for each person. After the last name on the first day is completed, begin the second day with a new set; continue for all 7 days..

//  //  Response Format:
// //  <ul>
// //   <h1>
// //   Date
// //   </h1>



// //         <li class="line"></li>
// // <li>Name</li>
// //   <li> Chore:</li> 
// //   <li>Time to complete: </li>
// //   <li>Incentive:</li>
// //   <li> Fun Fact:</li>
// //   <li>Inspirational Quote: </li>
// // </ul>
// // <ul>

// ***Use the format for each person in the ${promptNames}....
// There MUST be 7 days in your response starting with ${promptDate}..
// You are forbiden to response with an incomplete chart that has no more or less than exactly 7 days
// ****

// note: if oct 5 starts the week, oct 5th, 6th, 7th, 8th, 9th, 10th, and 11th must be listed. if nov 17 starts the week, the 17th-24th MUST be listed...etc..***THERE MUST BE 7 DAYS COMPLETED IN YOUR RESPONSE FOR THIS CHART****
//  `,
 


//  model: 'text-davinci-003',
//  max_tokens:3450,
//  temperature:.943
// });

















prompt:`

Write in jsonx format, a set of training data that will train and test a specific use case to use with openai. The use case will be to make chore charts. the chore charts will ALWAYS be 7 days long. The charts will NEVER be more than 7 days, or less than 7 days. When names are fed to the prompt via end user when the AI is live, there will be a set of key:values that will go with EVERY name that is provided for EACH day of the SEVEN day week that you will neatly be responding with when you recieve the names and the chore week's start date. The start date can be passed in whichever form is is recieved to you in in the request. If there is a typo, fix it, but this should be rare. 

Start with the training data that will fine tune the model and keep the cost of use down when people start catching on and using the chore chart each week. 

The output must be formatted in an HTML5 document and include headers/a table/lists/breaks/emphasis where the self explanatory locations are in a modern, sleek document. 

For each person on each day there must be a chore, and points value, a time limit, an incentive if a difficult or at least full energy/concentration task is completed successfully (task needs to be creatively provided as well). A fun fact for all ages. Each person on each day must also hace an inspirational quote to go with the day. There should be a week long motto that is boldly and correctly displayed with the data, and a peppy little pep talk that becomes personal to the members' of the chores that would at the very least, crack some smiles. The last day needs to have a sections for tallying all points and wrapping up the month .


training data:

textarea waiting on end user asking for names: 
user inputs: ${promptNames}
textarea waiting on end user asking for week start date(Monday's data):${promptDate}

Responses in order:
1)Chore Chart:
2)Your response as directed from data provided by end user (AKA Chore Chart Leader): `,





 model: 'text-davinci-003',
 max_tokens:3463,
 temperature:.84
});




















// DONE WITH AI CALL INSIDE MAIN FUNCTION--------------------------




setResult(res.data)

console.log(setResult)

console.log("RES.DATA :",res.data.choices[0].text)
if (output){output.innerHTML = res.data.choices[0].text}
setIsLoading(false)
}catch(error){
setIsLoading(false)
console.error("FROM 'generateChores', in the catch block, THE ERROR IS RELATED TO: ",error)
}
 console.log('You did it bud, carry on')
console.log("RESULT :",result)


 }







//  RETURN AKA FRONTEND --------------------------------

  return (


<div className="App">



    
        {/* HEADER-------- */}
        <header>
          <div className='line'></div>
                <h1 className='header-content'>Create this week's chores 👎<br/> and inspirations 👍</h1>
                <br/>
                <div className='line'></div>
        </header>

 
          
          {/* USER INPUT NAMES------- */}
          {/* <h1 className='header-content'>Names</h1> */}

          <textarea
                    id="userInputFieldNames"
                    title="Separate the names with commas and include as many as you want"
                    className='content-col ff'
                    placeholder="Names for this weeks chart"
                    onChange={(e) => {handleInputNames(e.target.value); setPromptNames(e.target.value)}}

                  />
                       
<br/>
<br/>

          {/* USER INPUT START DATE ----- */}
{/* <h1 className='header-content'>Week Start Date</h1> */}
              <textarea
                id="userInputFieldDate"
                className='content-col fff ff'
                title="Use any standard date format this this"
                placeholder="Chart start date"
                onChange={(e) => {handleDate(e.target.value); setPromptDate(e.target.value)}}
              />

                <button className="btn" onClick={generateChores} >
                  
                {isLoading ? (
                <span className='btn'>
          <i className="fa fa-spinner fa-spin loader" /> {`Generating Chores for the week for ${promptNames} `}
                  {/* Completing the chart for the week starting {promptDate} for {promptNames.replace(/\w+$/, 'and $&')}! */}
                  {/* Completing the chart for the week starting {promptDate} for {promptNames}! */}

                </span>
              ) : (
                isError ? "Error" : "Complete"
              )}     
              </button>


          
<div className='line'></div>
<div className='line'></div>
<div className='line'></div>


          {/* RESULTS FROM THE PROMPT---------- */}
                <section id='output'>
                
                <div id="returnedFromAi" className='col'>
                {result || result.length > 0 
                ?
                   <div className='explore result'>
<p id='output result-text'>
                    {result.choices[0].text}                                        
</p>
                
                </div>  

                : 
                <>
                
                </>                
              }
                </div></section>




              {/* LAST DIV---- */}
        </div>


  );
}
 
export default Chores;

